import React from "react"
import { Navigate } from "react-router-dom"

export const RootRoute = {
	path: '/',
	element: <Navigate to="/main/home" replace />
} 